import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { userActions } from '../../redux/actions/user.actions';
import EmailHistoryTable from './EmailHistoryTable.component';
import "../CompanyDetailsComponent/CompanyDetails.styles.scss";

const EmailHistoryComponent = () => {
  const dispatch = useDispatch();
  const companyProfile = useSelector((state) => state.companyProfile);
  const companyEmailLogs = useSelector((state) => state.companyEmailLogs);

  const { items } = companyProfile || {};
  const { company } = items || {};
  const { ACN: companyACN } = company || {};

  useEffect(() => {
    if (companyACN) {
      dispatch(userActions.getCompanyEmailLogsAsync(companyACN));
    }
    
  }, [dispatch, companyACN]);

  return (
    <EmailHistoryTable data={companyEmailLogs} />
  )
    
}
    export default EmailHistoryComponent;